import React from 'react'
import { Field, reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import BaseButton from 'components/UI/Buttons/BaseButton'
import { TextField } from 'redux-form-material-ui'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  root: {
    flexGrow: 1,
    fontWeight: 500
  },
  button: {
    margin: theme.spacing.unit,
    height: 32
  },
  alignRight: {
    display: 'flex',
    justifyContent: 'flex-end',
  }
})

class RegionsForm extends React.PureComponent {

  handleDiscard = () => {
    this.props.history.goBack()
  }

  render() {
    const {
      handleSubmit,
      pristine,
      reset,
      submitting,
      isEditing,
      classes,
    } = this.props;

    const formTitlePrefix = !isEditing ? 'Create' : 'Edit'

    return (
      <div className={classes.root}>
        <form onSubmit={handleSubmit}>

          <Grid container spacing={24}>
            <Grid item xs={8}>
              <Typography component="h2" variant="h5" gutterBottom>
                {`${formTitlePrefix} Region`}
              </Typography>
            </Grid>
            <Grid item xs={4} className={classes.alignRight}>
              <IconButton aria-label="Close" onClick={this.handleDiscard}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Field
                name="name"
                component={TextField}
                placeholder="Name"
                label="Region Name"
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                required
                fullWidth
                autoFocus
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <Field
                name="notes"
                component={TextField}
                placeholder="Notes"
                label="Notes"
                margin="normal"
                variant="outlined"
                fullWidth
                multiline
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <BaseButton
                type="submit"
                variant="contained"
                color="primary"
                className={classes.button}
                disabled={pristine || submitting}
              >
                Create
              </BaseButton>

              <BaseButton
                type="button"
                variant="outlined"
                className={classes.button}
                disabled={pristine || submitting}
                onClick={reset}
              >
                Clear
              </BaseButton>
            </Grid>
          </Grid>
        </form>
      </div >
    )
  }
}

RegionsForm.defaultProps = {
  isEditing: false,
}

RegionsForm = withStyles(styles)(RegionsForm)

export default reduxForm({
  form: 'RegionsForm'
})(RegionsForm)
